import i18n from "i18next";
import { z } from "zod";
import { getAtsMustNotBeInPastError, getEtcDateOrderError, notificationSchema } from "../utils";

const atsSchema = () =>
  z.object({
    ats: z.preprocess(
      (value) => {
        if (value === "" || value === null || value === undefined) return undefined;
        if (typeof value === "string" || typeof value === "number" || value instanceof Date) {
          return new Date(value);
        }
        return undefined;
      },
      z.date({
        required_error: i18n.t("form-validation.required", { label: "ATS" }),
        invalid_type_error: i18n.t("form-validation.invalid-date", { label: "ATS" }),
      }),
      z.string().min(1, i18n.t("form-validation.required", { label: "ATS" })),
    ),
  });

const etcSchema = () =>
  z.object({
    etc: z.preprocess(
      (value) => {
        if (value === "" || value === null || value === undefined) return undefined;
        if (typeof value === "string" || typeof value === "number" || value instanceof Date) {
          return new Date(value);
        }
        return undefined;
      },
      z
        .date({
          invalid_type_error: i18n.t("form-validation.invalid-date", { label: "ETC" }),
        })
        .optional(),
      z.string().min(1, i18n.t("form-validation.required", { label: "ETC" })),
    ),
  });

export const startShipToShipSchema = () =>
  atsSchema()
    .merge(etcSchema())
    .merge(notificationSchema)
    .superRefine((value, ctx) => {
      const atsError = getAtsMustNotBeInPastError(value.ats);

      if (atsError) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          path: ["ats"],
          message: atsError,
        });
      }

      const error = getEtcDateOrderError({ etc: value.etc, ats: value.ats });

      if (!error) {
        return;
      }

      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ["etc"],
        message: error,
      });
    });

export type StartShipToShipSchema = z.infer<ReturnType<typeof startShipToShipSchema>>;
